<mat-form-field
  *ngIf="control"
  fxFlex="100"
  class="facility-dobry-agent-form-field"
>
  <mat-label>{{ label }}</mat-label>

  <mat-select
    *ngIf="!returnKey"
    [formControl]="control"
    [required]="required"
    [multiple]="multiple"
    [compareWith]="compareFacility"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="filterControl"
        placeholderLabel="Wyszukaj placówkę..."
        noEntriesFoundLabel="Nie znaleziono">
      </ngx-mat-select-search>
    </mat-option>

    <mat-option *ngIf="!required && !multiple" [value]="''">
      Brak
    </mat-option>

    <mat-option
      *ngFor="let facility of (filteredFacilities !== null ? filteredFacilities : facilities)"
      [value]="facility" class="facility-mat-option"
    >
      <div class="facility-option">
        <div class="facility-option__name">
          {{ facility.name }}
        </div>

        <div class="facility-option__address">
          {{ getAddressLabel(facility) }}
        </div>

        <div
          class="facility-option__status"
          *ngIf="facility.asf24AddressUuid"
        >
          Powiązana z ASF24
        </div>
      </div>
    </mat-option>
  </mat-select>

  <mat-select
    *ngIf="returnKey"
    [formControl]="control"
    [required]="required"
    [multiple]="multiple"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="filterControl"
        placeholderLabel="Wyszukaj placówkę..."
        noEntriesFoundLabel="Nie znaleziono">
      </ngx-mat-select-search>
    </mat-option>

    <mat-option *ngIf="!required && !multiple" [value]="''">
      Brak
    </mat-option>

    <mat-option
      *ngFor="let facility of (filteredFacilities !== null ? filteredFacilities : facilities)"
      [value]="facility.uuid"
    >
      <div class="facility-option">
        <div class="facility-option__name">
          {{ facility.name }}
        </div>

        <div class="facility-option__address">
          {{ getAddressLabel(facility) }}
        </div>

        <div
          class="facility-option__status"
          *ngIf="facility.asf24AddressUuid"
        >
          Powiązana z ASF24
        </div>
      </div>
    </mat-option>
  </mat-select>

  <button
    *ngIf="hasValue() && !required && !control.disabled"
    matSuffix
    mat-icon-button
    type="button"
    aria-label="Clear"
    (click)="clearValue(); $event.stopPropagation()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-error *ngIf="control.hasError('required')">
    To pole jest wymagane
  </mat-error>

  <mat-error *ngIf="control.hasError('backendError')">
    {{ control.getError('backendError') }}
  </mat-error>
</mat-form-field>
